import React from "react";
import { SessionForm } from "./SessionForm";
import { DragZone } from "./DragZone";
import "./WorkSpace.scss";

export function Workspace(props) {
  const {
    weeks,
    weeksOptions,
    setWeeksAndSessions,
    activeSession,
    onReloadWeek,
    setActiveSessionEdit,
    onReload,
    onDropTemplate,
    onDragOver,
  } = props;

  return (
    <div className="workspace">
      <SessionForm
        session={activeSession}
        setActiveSessionEdit={setActiveSessionEdit}
        weeks={weeks}
        setWeeksAndSessions={setWeeksAndSessions}
        weeksOptions={weeksOptions}
        onReload={onReload}
        onReloadWeek={onReloadWeek}
      />
      <DragZone
        onDropTemplate={onDropTemplate}
        onDragOver={onDragOver}
        session={activeSession}
        setActiveSessionEdit={setActiveSessionEdit}
      />
    </div>
  );
}
